import { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { useController } from "react-hook-form";
import DateRangePicker from "../DateRangePicker";
import { formatDateRange, parseDateRange } from "./ticketFieldKinds";

/**
 * A ticket field that is a date period (e.g. Invoice Cycle) — picked from a calendar instead of
 * typed, so it can only ever hold a real range. The form value is the "YYYY-MM-DD to YYYY-MM-DD"
 * string the backend expects; the picker reads it back so a form reset clears it too.
 * useController registers the field, so the form's own required/format check covers it (an
 * unregistered field is skipped and the empty value only got caught by the backend).
 */
const TicketDateRangeField = ({ name, label }) => {
    const { field, fieldState } = useController({ name, defaultValue: "" });
    const parsed = parseDateRange(field.value);
    const defaultRange = useMemo(
        () => [{ startDate: parsed?.startDate || null, endDate: parsed?.endDate || null, key: "selection" }],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [field.value]
    );

    return (
        <Box>
            <DateRangePicker
                showTextBox
                label={label}
                defaultRange={defaultRange}
                maxDate={new Date()}
                onChange={(range) => {
                    const { startDate, endDate } = range?.[0] || {};
                    field.onChange(formatDateRange(startDate, endDate));
                }}
            />
            {fieldState.error?.message && (
                <Typography sx={{ fontSize: 12, color: "error.main", mt: 0.5, ml: 1.75 }}>{fieldState.error.message}</Typography>
            )}
        </Box>
    );
};

export default TicketDateRangeField;
